import { Navigate, useLocation, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/labels";

export const FullLoader = () => (
  <div className="min-h-screen grid place-items-center" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-emerald-700" />
  </div>
);

export const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
};

export const RoleRedirect = () => {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  return <Navigate to={user ? ROLE_HOME[user.role] : "/login"} replace />;
};

export const OpenActivity = () => {
  const { user } = useAuth();
  const { id } = useParams();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: `/buka/kegiatan/${id}` }} />;
  return <Navigate to={`${ROLE_HOME[user.role]}/kegiatan/${id}`} replace />;
};
